import { localStorageService } from '../../../../services/StorageService';
import { CacheKeys } from '../../../../_shared/constants/filters';
import { tradeSortOptionsByTradeState } from '../../../../_shared/hooks/trade/sort/constants/tradeSortMethods';
import { TradeState } from '../../../../_shared/types/trade';

const initializeSortMethodInTradeState = (tradeState: TradeState) => {
  const sortCache = localStorageService.getItem(CacheKeys.selectedSortOption);
  return (
    (sortCache && sortCache[tradeState]) ||
    tradeSortOptionsByTradeState[tradeState]?.find(s => s.isDefault).value
  );
};

export default {
  [TradeState.upcoming]: initializeSortMethodInTradeState(TradeState.upcoming),
  [TradeState.active]: initializeSortMethodInTradeState(TradeState.active)
};
